import * as Sentry from '@sentry/vue'
import { clearSlugAtCDA } from 'src/common/functions'
import { TokenService } from 'src/common/token-service'

const tokenService = new TokenService()
export const userService = {
  logout() {
    try {
      Sentry.configureScope((scope) => scope.setUser(null))
    } catch (e) {
      console.error(e)
    }
    tokenService.removeToken()

    if (!process.env.VUE_APP_CDA_URL) {
      return
    }

    return clearSlugAtCDA()
  },
}
